import React from 'react';

/**
 * An App configuration component that can be used when no configuration is needed.
 */
export function ZeroConfiguration() {
  return null;
}
